import React from 'react'

interface AcceptingProps {
	value: number,
	index: number,
}

type TabPanelProps = AcceptingProps

const TabPanel: React.FC<TabPanelProps> = (
	{
		value,
		index,
		children
	}
) => {
	return (
		<div hidden={value !== index}>
			{children}
		</div>
	)
}
export default TabPanel